import fsDetail from './fs-detail.vue'

export default fsDetail
